@import '../../../../../../constants/spacing.module.less';

.inventory-setup-step {
  max-width: 870px;
  margin: auto;
  padding: @space-0 @space-24;
}

.import-section {
  margin-top: @space-32;
}

.todo-cards-wrapper {
  width: 100%;
  margin: @space-24 auto @space-0;
  text-align: left;
}
